import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import ReportTabs from "../AllTabs/ReportTabs";

const HotelReport = () => {
  const { user, loading } = useAuth();
  const [pageLoading, setPageLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [totalProfit, setTotalProfit] = useState(0);

  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);

  const GetData = async (pageNumber) => {
    setPageLoading(true);
    try {
      const res = await apiService.post(
        `${config.GETCOMPANYHOTELBOOKINGS}/${user?.cid}`,
        pageSize,
        pageNumber
      );
      console.log(res);
      if (res) {
        setLists(res.data);
        const total = res.data.reduce(
          (sum, booking) => sum + (booking.transactionFee || 0),
          0
        );
        setTotalProfit(total);
      }
    } catch (error) {
      console.error("Failed to fetch hotel report data:", error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading, pageNumber]);

  if (loading) return <p>Loading user data...</p>;

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <ReportTabs pageName="HOTELREPORT" />
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table
                      className="table align-middle table-striped table-hover"
                      id="reportTable"
                    >
                      <thead className="bg-soft-info bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Booking No</th>
                          <th>Traveler Name</th>
                          <th>Booking Status</th>
                          <th>Payment Status</th>
                          <th>Purchase Price</th>
                          <th>Sale Price</th>
                          <th>Profit</th>
                        </tr>
                      </thead>
                      {pageLoading ? (
                        <tbody>
                          <tr>
                            <td colSpan="8" className="text-center">
                              <img
                                src="/assets/images/loader.webp"
                                width="64px"
                                height="64px"
                                alt="Loading..."
                              />
                              <p>Loading Report, Please wait...</p>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <>
                          <tbody className="list form-check-all">
                            {lists.length > 0 ? (
                              lists.map((booking, index) => (
                                <tr key={booking.hotelBookingId}>
                                  <td>{index + 1}</td>
                                  <td>{booking.bookingNo}</td>
                                  <td>{booking.travellerName}</td>
                                  <td>
                                    {booking.bookingStatus === "CONFIRMED" ? (
                                      <span className="badge bg-success">
                                        {booking.bookingStatus}
                                      </span>
                                    ) : (
                                      <span className="badge bg-warning text-dark">
                                        {booking.bookingStatus}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {booking.paymentStatus === "SUCCESS" ? (
                                      <span className="badge bg-success">
                                        {booking.paymentStatus}
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        {booking.paymentStatus}
                                      </span>
                                    )}
                                  </td>
                                  <td>{(booking.netPrice || 0).toFixed(2)}</td>
                                  <td>{booking.totalPrice.toFixed(2)}</td>
                                  <td className="fw-bold text-success">
                                    {(booking.convenienceFee || 0).toFixed(2)}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  No records found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td
                                colSpan="7"
                                className="text-end fw-bold fs-14"
                              >
                                Grand Total Profit:
                              </td>
                              <td className="fw-bold fs-14 text-success">
                                {totalProfit.toFixed(2)}
                              </td>
                            </tr>
                          </tfoot>
                        </>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelReport;
